import { formatDate } from '@btime/helpers'

export const getReplyValue = reply => {
  if (!reply) {
    return ''
  }
  if (reply.question.type.name === 'sign') {
    return reply.value.name
  }
  if (reply.question.type.name === 'select') {
    return reply.value?.name?.trim() || 'N/A'
  }
  return reply.value || 'N/A'
}

export const filterRepliesByQuestionType = (replies, typpeName) => {
  return replies.filter(reply => reply.question.type.name === typpeName)
}

export const findReplyByQuestionId = (replies, questionId) => {
  return replies.find(reply => reply.question.id === questionId)
}

export const findReplyByQuestionName = (replies, name) => {
  return replies.find(reply => reply.question.name === name)
}

export const toDateFormat = (date, format) => {
  if (!date) {
    return 'Não informada'
  }
  return formatDate(format, date)
}

export const toPtNumber = number => {
  if (!number) return 0

  return number.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}
